import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isLoggedId = localStorage.getItem("isLoggedId") === "true";
  console.log("User Authenticated:", isLoggedId);
  return isLoggedId ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
